import React from 'react'
import Radium from 'proofpoint-radium'
import ReactHTMLParser from 'react-html-parser'

import CoreRenderFunction from '../../core/render'

const LI = ({
  children,
  id,
  style,
  className,
  languages,
  selectedLanguageShortname,
  updateMainContainerState
}) => {
  return (
    <li
      id={ id }
      style={ style }
      className={ className }>
      {
        children && children.length > 0 && children.map( item => {
          return (
            <CoreRenderFunction
              item={ item }
              updateMainContainerState={ updateMainContainerState }
              languages={ languages }
              selectedLanguageShortname={ selectedLanguageShortname } />
          )
        })
      }
    </li>
  )
}

export default Radium( LI )